
import isNil from 'lodash/isNil';

import DialogObjectInfo from './DialogObjectInfo';

function showObjectInfoInDataModule(options) {
    if (options.dataActions) {
        if (!isNil(options.message)) {
            options.dataActions.setMessage(options.message);
        }
        if (options.objects) {
            options.dataActions.setObjectList(
                options.objects,
                options.finished,
                options.coordinates
            );
            if (options.finished && (options.objects.length === 1)) {
                options.dataActions.setObject(options.objects[0], options.sourceType);
            }
        }
    }
}

function showObjectInfoInDialog(options) {
    if (options.objects) {
        DialogObjectInfo.showObjects(
            options.mapLayers, options.objects, options.appConfig
        );
    } else {
        DialogObjectInfo.showMessage(options.message);
    }
}

function isAvailableDataModule(options) {
    let isAvailable = false;
    if (options.appModules) {
        isAvailable = (options.appModules.indexOf('data') !== -1);
    }
    return isAvailable;
}

function isSearchPins(options) {
    let flag = false;
    if (options && options.objects && options.objects.length > 0) {
        if (options.objects[0].layerId === 'search_pins') {
            flag = true;
        }
    }
    return flag;
}

export default function showObjectsInfo(options) {
    if (!isSearchPins(options)) {
        if (isAvailableDataModule(options)) {
            if (options.appActions) {
                options.appActions.setUiValue('activePanelName', 'data');
            }
            showObjectInfoInDataModule(options)
        } else {
            showObjectInfoInDialog(options);
        }
    }
}
